// extracted by mini-css-extract-plugin
module.exports = {"messageIcon":"AboutFundraiser_messageIcon__YP_9b","messageFundraiserButton":"AboutFundraiser_messageFundraiserButton__eLCzq"};